import { Slide } from "@jelly/lesson";

import theory from "../../theory";

import air_he from "./components/air-he";
import he_air from "./components/he-air";
import air_ne from "./components/air-ne";
import ne_air from "./components/ne-air";
import air_air from "./components/air-air";
import zc1_zc2 from "./components/zc1-zc2";
import zc2_zc1 from "./components/zc2-zc1";

const principle: Slide = {
  descriptionHtml:
    " A plane wave propagates in medium 1 (left) and is incident on the interface medium 1 / medium 2 at the angle of incidence \\theta_i. At the interface it is reflected and transmitted with the angles \\theta<sub>r</sub> and \\theta<sub>t</sub> according to the Snell-Descartes laws: \\theta<sub>r</sub> = \\theta<sub>i</sub> and sin \\theta<sub>t</sub> = c2/c1 sin \\theta<sub>i</sub>. You can change \theta_i and see how the pressure fields evolve in media 1 and 2 for different cases of media. The dependencies of the pressure level on \\theta<sub>i</sub> and the media deserve your special attention! Also see how the pressure along the interface normal in medium 2 decays exponentially as soon as the critical angle is exceeded.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          items: [
            { name: "air / He" },
            { name: "He / air" },
            { name: "air / Ne" },
            { name: "Ne / air" },
            { name: "air / air" },
            { name: "Z<sub>c1</sub> >> Z<sub>c2</sub>" },
            { name: "Z<sub>c1</sub> << Z<sub>c2</sub>" },
          ],
          options: {},
        },
      ],
      extraContent: [[]],
      components: [air_he, he_air, air_ne, ne_air, air_air, zc1_zc2, zc2_zc1],
    },
  },
};

export default principle;
